// extracted by mini-css-extract-plugin
module.exports = {"grid":"loader_grid__R_OiF","sk1":"loader_sk1__f7kJm","grid2":"loader_grid2__Gcgs9","grid2_skeletor":"loader_grid2_skeletor__3gukO"};